var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideosList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#bfbfbf",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 6.41699C20.4441 6.41699 21.25 7.22288 21.25 8.21699V18.7837C21.25 19.7778 20.4441 20.5837 19.45 20.5837H5.55C4.55589 20.5837 3.75 19.7778 3.75 18.7837V8.21699C3.75 7.22288 4.55589 6.41699 5.55 6.41699H19.45ZM4.58333 18.7503C4.58333 19.3026 5.03105 19.7503 5.58333 19.7503H19.4167C19.969 19.7503 20.4167 19.3026 20.4167 18.7503V8.25032C20.4167 7.69804 19.969 7.25033 19.4167 7.25033H5.58333C5.03105 7.25033 4.58333 7.69804 4.58333 8.25033V18.7503ZM10.2851 16.92V10.2409L15.9845 13.5805L10.2851 16.92ZM11.1184 11.6951V15.4659L14.3361 13.5805L11.1184 11.6951ZM8.95475 5.75033C8.72463 5.75033 8.53808 5.56378 8.53808 5.33366C8.53808 5.10354 8.72463 4.91699 8.95475 4.91699H19.5833C19.8135 4.91699 20 5.10354 20 5.33366C20 5.56378 19.8135 5.75033 19.5833 5.75033H8.95475ZM7.08333 4.25033C6.85321 4.25033 6.66667 4.06378 6.66667 3.83366C6.66667 3.60354 6.85321 3.41699 7.08333 3.41699H17.9167C18.1468 3.41699 18.3333 3.60354 18.3333 3.83366C18.3333 4.06378 18.1468 4.25033 17.9167 4.25033H7.08333Z",
    fill: "#bfbfbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4463 4.91699H5.41667C5.18655 4.91699 5 5.10354 5 5.33366C5 5.56378 5.18655 5.75033 5.41667 5.75033H7.4463C7.67642 5.75033 7.86297 5.56378 7.86297 5.33366C7.86297 5.10354 7.67642 4.91699 7.4463 4.91699Z",
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideosList);
export default __webpack_public_path__ + "static/media/icon-videos-list.0a0fd4da5e737b39d5b9cba228524955.svg";
export { ForwardRef as ReactComponent };